/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TextImageContent } from '../../models/text-image-content';

export interface ApiMasterTextImageContentGetActiveGet$Params {
}

export function apiMasterTextImageContentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterTextImageContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TextImageContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTextImageContentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TextImageContent>>;
    })
  );
}

apiMasterTextImageContentGetActiveGet.PATH = '/api/Master/TextImageContent/GetActive';
